module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Briefcase-5eb43cc473701ea7e99c192bc90a5075.svg";